import { takeEvery, takeLatest, call, put, fork } from 'redux-saga/effects';
// import { toast } from 'react-toastify';
import toast from '../components/Toastify';
import * as api from '../services/api';
import { load, loaded } from 'ducks/loading';
import * as actions from '../ducks/widget';
import * as authActions from '../ducks/auth';
import { browserHistory } from 'react-router';
// import * as apiIntegrate from '../services/apiIntegrate';
// const delay = (ms) => new Promise(res => setTimeout(res, ms));


// const params = (new URL(window.location)).searchParams;
// const widgetID = params.get('id');

function* getActiveIntgList() {
  try {
    yield put(load());
    const res = yield call(api.GET, '/getActiveIntgList');
    if (res.status == 'success') {
      yield put(actions.getActiveIntgListSuccess(res.data));
    }
    else {
      yield put(actions.getActiveIntgListError(true));
      toast.error('Error in get active integration list');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.getActiveIntgListError(true));
  }
}

function* getWidgetById(action) {
  try {
    yield put(load());
    const res = yield call(api.GET, '/getWidgetById?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.getWidgetByIdSuccess(res.data));
    }
    else {
      toast.error('Error in get data');
    }
    yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* getIconList() {
  try {
    // yield put(load());
    const res = yield call(api.GET, '/getIconList');
    if (res.status == 'success') {
      yield put(actions.getIconListSuccess(res.data));
    }
    else {
      toast.error('Error in get icon list');
      yield put(actions.getIconListError(true));
    }
    // yield put(loaded());
  } catch (error) {
    yield put(actions.getIconListError(true));
  }
}

function* deleteIcon(action) {
  try {
    yield put(load());
    const res = yield call(api.DELETE, '/deleteIcon?_id=' + action.data.id + '&url=' + action.data.url);
    if (res.status == 'success') {
      yield put(actions.getIconList());
      toast.info(res.m);
    }
    else {
      toast.error('Error in delete icon');
      yield put(actions.deleteIconError(true));
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.deleteIconError(true));
  }
}

function* getWidgetData(action) {
  try {
    // yield put(load());
    let webData = action.data;
    if (localStorage.getItem('userTyp') == 'instafeed') {
      webData.type = 'instafeed';
    }
    const res = yield call(api.POST, '/getWidgetData', webData);
    localStorage.setItem('W_LOAD_DATA', false);
    localStorage.setItem('W_LOAD_DS_DATA', false);
    if (res.status == 'success') {
      yield put(actions.getWidgetDataSuccess(res.data));
    }
    else {
      yield put(actions.getWidgetDataError(true));
    }
    // yield put(loaded());
  }
  catch (e) {
    yield put(actions.getWidgetDataError(true));
  }
}

function* addDataSrc(action) {
  try {
    // yield put(load());
    //delete action.data.widgetById.cnf;
    //delete action.data.widgetById.dsi;
    // if (action.data.iin == 'googlereview') {
    //   yield call(apiIntegrate.POST, '/googlereview/createPage', { _id: action.data.uid, name: action.data.pid });
    // }
    // if (action.data.iin == 'facebookpost') {
    //   yield call(apiIntegrate.POST, '/facebookpost/createPage', { _id: action.data.uid, pgid: action.data.pid });
    // }
    // if (action.data.iin == 'facebook') {
    //   yield call(apiIntegrate.POST, '/facebook/createPage', { _id: action.data.uid, pgid: action.data.pid });
    // }
    // if (action.data.iin == 'instagrampost') {
    //   yield call(apiIntegrate.POST, '/instapost/createPage', { _id: action.data.uid, pgid: action.data.pid });
    // }
    // if (action.data.iin == 'googleplace') {
    //   yield call(apiIntegrate.POST, '/googleplace/create', action.data);
    // }
    // const dataObj = {
    //   uid: action.data.uid,
    //   _id: action.data._id,
    //   pid: action.data.pid,
    //   fn: action.data.fn,
    //   cn: action.data.cn,
    //   exkw: action.data.exkw,
    //   inkw: action.data.inkw,
    //   ihwc: action.data.ihwc,
    //   ihwi: action.data.ihwi,
    //   mnrt: action.data.mnrt,
    //   pgrtngavg:pgrtngavg ,
    //   pgrtngcnt:pgrtngcnt,
    //   rmk:rmk
    // };
    const dataObj = action.data;
    localStorage.setItem('W_LOAD_DATA', true);
    const res = yield call(api.POST, '/addDataSrc', dataObj);
    localStorage.setItem('W_LOAD_DS_DATA', false);
    if (res.status == 'success') {
      // yield put(actions.getWidgetByIdSuccess(res.data));
      //for get latest wall data
      let obj = {
        arrDsi: res.data.dsi,
        cn: res.data.cn,
        exkw: dataObj.exkw,
        inkw: dataObj.inkw,
        ihwc: dataObj.ihwc,
        ihwi: dataObj.ihwi,
        mnrt: dataObj.mnrt,
        flag: true
      };
      yield put(actions.getWidgetData(obj));
      // yield put(actions.interValCall(obj));
      toast.success(res.m);
    }
    else {
      yield put(actions.addDataSrcError(true));
      toast.error('Error in add data source');
    }
    // yield put(loaded());
  } catch (error) {
    console.log(error, '===error');
    yield put(actions.addDataSrcError(true));
  }
}

// async function* interValCall(action) {
//   try {
//     let _dataFlag = action.data.flag;
//     if (_dataFlag) {
//       if (!localStorage.getItem('WIDGET_DATA_LOADER')) {
//         yield put(await actions.getWidgetData(action.data));
//         const res = yield call(api.GET, '/getWidgetById?_id=' + widgetID);
//         console.log(res, '====res');
//         // console.log(action.data, '====action.data');
//         // console.log(widgetID, '===widgetID');
//         if (res.status == 'success') {
//           yield put(await actions.getWidgetByIdSuccess(res.data));
//         }
//         _dataFlag = false;
//         yield call(await interValCall, action);
//       }
//       else {
//         yield delay(4000);
//         _dataFlag = true;
//         yield call(await interValCall, action);
//       }
//     }
//   } catch (error) {
//     console.log(error);
//   }
// }

function* delDataSrc(action) {
  try {
    //yield put(load());
    let res;
    // if (action.data.iin == 'googlereview') {
    //   yield call(apiIntegrate.POST, '/googlereview/deletePage', { _id: action.data.uid, name: action.data.pid });
    // }
    // if (action.data.iin == 'facebookpost') {
    //   yield call(apiIntegrate.POST, '/facebookpost/deletePage', { _id: action.data.uid, pgid: action.data.pid });
    // }
    // if (action.data.iin == 'facebookreview') {
    //   yield call(apiIntegrate.POST, '/facebookreview/deletePage', { _id: action.data.uid, pgid: action.data.pid });
    // }
    // const dataObj = {
    //   uid: action.data.uid,
    //   _id: action.data._id,
    //   pid: action.data.pid,
    //   fn: action.data.fn,
    //   cn: action.data.cn,
    //   exkw: action.data.widgetById.exkw,
    //   inkw: action.data.widgetById.inkw,
    //   ihwc: action.data.widgetById.ihwc,
    //   ihwi: action.data.widgetById.ihwi,
    //   mnrt: action.data.widgetById.mnrt,
    // };
    const dataObj = {
      uid: action.data.uid,
      _id: action.data._id,
      pid: action.data.pid,
      fn: action.data.fn,
      cn: action.data.cn,
      exkw: action.data.exkw,
      inkw: action.data.inkw,
      ihwc: action.data.ihwc,
      ihwi: action.data.ihwi,
      mnrt: action.data.mnrt,
    };
    localStorage.setItem('W_LOAD_DATA', true);
    if (action.data.pid) {
      res = yield call(api.DELETE, '/delDataSrc?uid=' +
        action.data.uid +
        '&_id=' +
        action.data._id +
        '&pid=' +
        action.data.pid +
        '&cn=' +
        action.data.cn +
        '&iin=' +
        action.data.iin
      );
    }
    else {
      res = yield call(api.DELETE, '/delDataSrc?uid=' +
        action.data.uid +
        '&_id=' +
        action.data._id +
        '&cn=' +
        action.data.cn +
        '&iin=' +
        action.data.iin
      );
    }
    if (res.status == 'success') {
      localStorage.setItem('W_LOAD_DS_DATA', false);
      // localStorage.setItem('W_LOAD_DATA', false);
      // yield put(actions.getWidgetByIdSuccess(res.data));
      //for get latest wall data
      // let obj = {
      //   arrDsi: res.data.dsi,
      //   cn: res.data.cn,
      //   exkw: action.data.widgetById.exkw,
      //   inkw: action.data.widgetById.inkw,
      //   ihwc: action.data.widgetById.ihwc,
      //   ihwi: action.data.widgetById.ihwi,
      //   mnrt: action.data.widgetById.mnrt
      // };
      let obj = {
        arrDsi: res.data.dsi,
        cn: res.data.cn,
        exkw: dataObj.exkw,
        inkw: dataObj.inkw,
        ihwc: dataObj.ihwc,
        ihwi: dataObj.ihwi,
        mnrt: dataObj.mnrt,
        flag: false
      };
      yield put(actions.getWidgetData(obj));
      //for get latest widget data
      // let obj = {
      //   isFrmFront: false,
      //   wallId: action.data._id,
      //   cn: action.data.cn
      // };
      // yield put(actions.getWidgetData(obj));
      toast.info(res.m);
    }
    else {
      yield put(actions.delDataSrcError(true));
      toast.error('Error in delete data source');
    }
    //yield put(loaded());
  } catch (error) {
    console.log(error, '===error');
    yield put(actions.delDataSrcError(true));
  }
}

function* updWidgetCnf(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/updWidgetCnf', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.getWidgetByIdSuccess(res.data));
      // let obj = {
      //   wallId: res.data._id,
      //   cn: res.data.cn
      // };
      // yield put(actions.getWidgetData(obj));
    }
    else {
      toast.error('Error in update record');
    }
    yield put(loaded());
  } catch (e) {
    toast.error(e.message);
  }
}

//create widget
function* createWidget(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/createWidget', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      // yield put(actions.createWallSuccess(res.status));
      browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + res.data.wid + '&id=' + res.data._id + '&cn=' + res.data.cn + '&wdtnm=' + res.data.wdtnm);
      yield put(actions.getWidgetByIdSuccess(res.data));
      let obj = {
        wid: localStorage.getItem('WIDTP'),
        pvd: localStorage.getItem('pvd')
      };
      yield put(actions.getWidgetByUser(obj));
    }
    else {
      toast.error('Error in create Wall');
    }
    yield put(loaded());
  } catch (e) {
    toast.error(e.message);
  }
}

function* getWidgetByUser(action) {
  try {
    yield put(load());
    const res = yield call(api.GET, '/getWidgetByUser?wid=' + action.data.wid + '&pvd=' + action.data.pvd);
    if (res.status == 'success') {
      yield put(actions.getWidgetByUserSuccess(res.data));
    }
    else {
      toast.error('error in get data');
    }
    yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* updWidgetStatus(action) {
  try {
    const res = yield call(api.POST, '/updWidgetStatus', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
    }
    else if (res.status == 'limit') {
      if (action.data.togl && action.data.togl == true) {
        let obj = {
          _id: action.data._id,
          dt: new Date().getTime()
        };
        yield put(actions.updWidgetStatusSuccess(obj));
      }
      else {
        toast.info(res.m);
      }
    }
    else {
      yield put(actions.updWidgetStatusError(true));
      toast.error('Failed to update Wall status');
    }
  } catch (e) {
    toast.error(e.message);
  }
}

function* delUserWidget(action) {
  try {
    yield put(load());
    const res = yield call(api.DELETE, '/delUserWidget?_id=' + action.data.id + '&unqid=' + action.data.unqid + '&cn=' + action.data.cn);
    if (res.status == 'success') {
      toast.info(res.m);
    }
    else {
      toast.error('error in delete wall');
    }
    yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

function* getAnalytic(action) {
  try {
    // yield put(load());
    const res = yield call(api.GET, '/getAnalytic?_id=' + action.data);
    if (res.status == 'success') {
      yield put(actions.getAnalyticSuccess(res.data));
    }
    else {
      toast.error('error in get data');
    }
    //yield put(loaded());
  }
  catch (e) {
    toast.error(e.message);
  }
}

// hireUs
function* createHireUs(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/createHireUs', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
    }
    else {
      toast.error('Error in send data');
    }
    yield put(loaded());
  }
  catch (error) {
    toast.error(error);
  }
}

//update widget name
function* updWidgetName(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/updWidgetName', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
    }
    else {
      toast.error('Error in send data');
    }
    yield put(loaded());
  }
  catch (error) {
    toast.error(error);
  }
}

function* redisCreateWidget(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/redisCreateWidget', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      window.parent.location.href = process.env.REACT_APP_FRONTEND_URL + '/signup?q=' + res.data;
    }
    else {
      toast.error('Error in create Wall');
    }
    yield put(loaded());
  }
  catch (error) {
    toast.error(error);
  }
}

function* createCloneWidget(action) {
  try {
    yield put(load());
    const res = yield call(api.POST, '/createCloneWidget', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      browserHistory.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist?wid=' + res.data.wid + '&id=' + res.data._id + '&cn=' + res.data.cn + '&wdtnm=' + res.data.wdtnm);
      yield put(actions.getWidgetByIdSuccess(res.data));
    }
    else {
      yield put(actions.createCloneWidgetError(true));
      toast.error('Error in create clone Wall');
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.createCloneWidgetError(true));
  }
}

function* addShpWidgetDiv(action) {
  try {
    //yield put(load());
    const res = yield call(api.POST, '/addShpWidgetDiv', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.addShpWidgetDivSuccess(res.data));
    }
    else {
      toast.error('Error in add shopify widget');
    }
    // yield put(loaded());
  } catch (error) {
    toast.error(error);
  }
}

function* getShpThemeList(action) {
  try {
    // yield put(load());
    const res = yield call(api.POST, '/shopify/getTheme', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(authActions.getProfileSuccess(res.data));
    }
    else {
      toast.error('Error in get shopify page list');
    }
    // yield put(loaded());
  } catch (error) {
    toast.error(error);
  }
}

function* deleteShpWidgetDiv(action) {
  try {
    // yield put(load());
    const res = yield call(api.POST, '/deleteShpWidgetDiv', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.addShpWidgetDivSuccess(res.data));
    }
    else {
      toast.error('Error in delete shopify Wall div');
    }
    // yield put(loaded());
  } catch (error) {
    toast.error(error);
  }
}

function* updWidgetIcon(action) {
  try {
    // yield put(load());
    const res = yield call(api.POST, '/updwidgetImg', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.getIconListSuccess(res.data));
    }
    else {
      toast.error('Error in update Wall');
    }
    // yield put(loaded());
  } catch (error) {
    toast.error(error.message);
  }
}

function* onChangeUpdateWidget(action) {
  try {
    //yield put(load());
    const res = yield call(api.POST, '/onChangeUpdateWidget', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.getWidgetByIdSuccess(res.data));
    }
    else {
      toast.error('Error in update record');
    }
    //yield put(loaded());
  } catch (e) {
    toast.error(e.message);
  }
}

function* onChangeSaveFilter(action) {
  try {
    //yield put(load());
    const res = yield call(api.POST, '/onChangeSaveFilter', action.data);
    if (res.status == 'success') {
      toast.success(res.m);
      yield put(actions.getWidgetByIdSuccess(res.data));
    }
    else {
      toast.error('Error in update record');
    }
    //yield put(loaded());
  } catch (e) {
    toast.error(e.message);
  }
}

function* updSchemaValue(action) {
  try {
    //yield put(load());
    const res = yield call(api.POST, '/updSchemaValue', action.data);
    if (res.status == 'success') {
      toast.success('Data updated successfully');
      yield put(actions.getWidgetByIdSuccess(res.data));
    }
    else {
      toast.error('Error in update record');
    }
    //yield put(loaded());
  } catch (e) {
    toast.error(e.message);
  }
}

export function* watch() {
  yield takeEvery(actions.REDIS_CREATE_WIDGET, redisCreateWidget);
  yield takeEvery(actions.UPD_WIDGET_NAME, updWidgetName);
  yield takeEvery(actions.CREATE_HIRE_US, createHireUs);
  yield takeEvery(actions.GET_ACTIVE_INTG_LIST, getActiveIntgList);
  yield takeEvery(actions.GET_WIDGET_BY_ID, getWidgetById);
  yield takeEvery(actions.GET_IMG_LIST, getIconList);
  yield takeEvery(actions.DELETE_ICON, deleteIcon);
  yield takeLatest(actions.GET_WIDGET_DATA, getWidgetData);
  yield takeEvery(actions.ADD_DATA_SRC, addDataSrc);
  yield takeEvery(actions.DELETE_DATA_SRC, delDataSrc);
  yield takeEvery(actions.UPD_WIDGET_CNF, updWidgetCnf);
  yield takeEvery(actions.CREATE_WIDGET, createWidget);
  yield takeEvery(actions.GET_WIDGET_BY_USER, getWidgetByUser);
  yield takeEvery(actions.UPD_WIDGET_STATUS, updWidgetStatus);
  yield takeEvery(actions.DEL_USER_WIDGET, delUserWidget);
  yield takeEvery(actions.GET_ANALYTICS, getAnalytic);
  yield takeEvery(actions.CREATE_CLONE_WIDGET, createCloneWidget);
  // yield takeEvery(actions.INTERVAL_CALL_FUNCTION, interValCall);
  yield takeEvery(actions.ADD_SHP_WIDGET_DIV, addShpWidgetDiv);
  yield takeEvery(actions.GET_SHP_THEME_LIST, getShpThemeList);
  yield takeEvery(actions.DELETE_SHP_WIDGET_DIV, deleteShpWidgetDiv);
  yield takeEvery(actions.UPD_WIDGET_ICON, updWidgetIcon);
  yield takeEvery(actions.ON_CHANGE_UPD_WIDGET, onChangeUpdateWidget);
  yield takeEvery(actions.ON_CHANGE_SAVE_FILTER, onChangeSaveFilter);
  yield takeEvery(actions.UPD_SCHEMA_VALUE, updSchemaValue);
}

export default function* rootSaga() {
  yield [
    fork(watch)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/widget.js